const ACCESS_TOKEN = 'ACCESS_TOKEN'
const MENUS_LIST = 'menus_list'

export function getToken () {
  return sessionStorage.getItem(ACCESS_TOKEN)
}

export function setToken (token) {
  return sessionStorage.setItem(ACCESS_TOKEN, token)
}

export function removeToken () {
  return sessionStorage.removeItem(ACCESS_TOKEN)
}

// 保存菜单
export function setRouters(menus) {
  window.sessionStorage.setItem(MENUS_LIST, JSON.stringify(menus))
}

export function getRouters() {
  return JSON.parse(window.sessionStorage.getItem(MENUS_LIST))
}



// WEBPACK FOOTER //
// ./src/utils/auth.js